import React from 'react';
import Slider from 'react-slick';
import { Search, BarChart3, Handshake, Eye, Scale, Headphones, Verified } from 'lucide-react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const wcuData = [
  {
    icon: <Search size={30} />,
    title: 'Simplified Project Search',
    desc: 'Easily find the right property with our streamlined and smart search tools.',
  },
  {
    icon: <BarChart3 size={30} />,
    title: 'Market Analysis',
    desc: 'Get in-depth insights and data-driven analysis for better property decisions.',
  },
  {
    icon: <Handshake size={30} />,
    title: 'Brokerage Free Transactions',
    desc: 'Enjoy hassle-free property deals without paying unnecessary brokerage fees.',
  },
  {
    icon: <Eye size={30} />,
    title: 'Transparency & Efficiency',
    desc: 'We maintain 100% clarity and efficiency in every transaction and process.',
  },
  {
    icon: <Scale size={30} />,
    title: 'Unbiased Opinions',
    desc: 'Get fair and neutral property advice that’s always in your best interest.',
  },
  {
    icon: <Headphones size={30} />,
    title: 'Post Sales Assistance',
    desc: 'From documentation to support, we assist you even after the purchase.',
  },
  {
    icon: <Verified size={30} />,
    title: 'Verified Property Data Base ',
    desc: 'Get Verified Property Data Base for your dream home',
  },
];

const settings = {
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 3,
  arrows: false,
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 2500,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        centerMode: true,
        centerPadding: '40px',
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '30px',
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        centerMode: false,
        centerPadding: '0px',
      },
    },
  ],
};

const WhyChooseUs = () => {
  return (
    <section className="big-house-carousel-wrapper">
      <h2 className="big-house-carousel-title">Why Choose Us</h2>
      <Slider {...settings}>
        {wcuData.map((item, index) => (
          <div key={index} className="big-house-carousel-slide">
            <div className="big-house-carousel-card">
              <div className="big-house-carousel-icon-box">{item.icon}</div>
              <h3 className="big-house-carousel-card-title">{item.title}</h3>
              <p className="big-house-carousel-card-desc">{item.desc}</p>
              <span className="big-house-carousel-card-count">
                {String(index + 1).padStart(2, '0')}
              </span>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default WhyChooseUs;
